import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './responsive.css';
import LandingPage from './LandingPage';
import Register from './Register';
import Login from './Login';
import SelectServices from './SelectServices';
import AddCar from './AddCar';
import CustomerDashboard from './CustomerDashboard';
import AdminDashboard from './AdminDashboard.js';
import EditProfile from './EditProfile';
import ForgetPassword from './ForgetPassword.js';
import ResetPassword from './ResetPassword.js';
import ReviewForm from './ReviewForm';  // اضافه کردن کامپوننت ثبت نظرات
import GatewayPage from './GatewayPage';
import ServiceInfoPage from './ServiceInfoPage';
import AddCarVIN from './AddCarVIN';
import AddCarManual from './AddCarManual';


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<GatewayPage />} />
                <Route path="/mobile" element={<LandingPage />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/customer-dashboard" element={<CustomerDashboard />} />
                <Route path="/admin-dashboard" element={<AdminDashboard key="admin" />} />
                <Route path="/select-services" element={<SelectServices />} />
                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/forget-password" element={<ForgetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/review" element={<ReviewForm />} />  {/* مسیر ثبت نظرات */}
                <Route path="/mechanical-shop" element={<ServiceInfoPage serviceName="Mechanical Shop Services" />} />
                <Route path="/body-shop" element={<ServiceInfoPage serviceName="Body & Paint Shop Services" />} />
                <Route path="/add-car" element={<AddCar />} />
                <Route path="/add-car-manual" element={<AddCarManual />} />
                <Route path="/add-car-vin" element={<AddCarVIN />} />
            </Routes>
        </Router>
    );
}

export default App;
